<template>
  <a
    v-if="href"
    :class="[$style.iconButton, $style.iconButtonSize]"
    :href="href"
    :rel="rel"
    :target="target"
    :title="title"
  >
    <slot />
  </a>
  <button
    v-else
    :class="[$style.iconButton, $style.iconButtonSize]"
    :title="title"
    @click="handleClick"
  >
    <slot />
  </button>
</template>
<script>
export default {
  name: 'IconButton',

  props: {
    href: {
      default: '',
      type: String,
    },
    rel: {
      default: 'noopener noreferrer',
      type: String,
    },
    target: {
      default: '_blank',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
  },

  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style module scoped>
a.iconButton,
button.iconButton {
  background: transparent;
  border: 0 none;
  color: inherit;
  cursor: pointer;
  display: inline-block;
  font: inherit;
  margin: 0;
  padding: 0;
}

a.iconButton:focus,
button.iconButton:focus {
  outline: none;
}

.iconButtonSize {
  height: 1.8rem;
  width: 1.8rem;
}
</style>
